module.exports = __webpack_public_path__ + "fonts/Roboto-Light.0a80ecc0.woff";